import { Divider, SideNote } from "../../../../src/components/tufte";
import SafeLink from "../../../../src/components/SafeLink";
import orderedGif from "../../../../src/img/ordered.gif";
import unorderedGif from "../../../../src/img/unordered.gif";
import * as React from 'react';
export default {
  Divider,
  SideNote,
  SafeLink,
  orderedGif,
  unorderedGif,
  React
};